"use client"

import { ContactStoreInfoProps } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/ContactStoreInfo/types"
import { ComponentConfig, CustomField } from "@measured/puck"
import { StoreSelect } from "../../../components/StoreSelect"
import { RenderConfig } from "./RenderConfig"

export const ContactStoreInfo: ComponentConfig<ContactStoreInfoProps> = {
    label: "Tamda OC | Contact Store Info",
    fields: {
        title: {
            label: "Title",
            type: "text",
        },
        selectedStore: {
            label: "Selected Store",
            type: "custom",
            render: ({ value, onChange }) => (
                <StoreSelect
                    value={value}
                    onChange={onChange}
                />
            ),
        } as CustomField<{ storeId: number; storeName: string } | undefined>,
        className: {
            label: "Class Name",
            type: "text",
        },
    },
    defaultProps: {
        title: "LIÊN HỆ",
        selectedStore: undefined,
        className: "",
    },
    ...RenderConfig,
}
